
import { defineComponent } from "vue";
import Button from "../Generics/Button.vue";
import ButtonRequest from "../Generics/ButtonRequest.vue";

export default defineComponent({
  name: "FooterBank",
  components: { Button, ButtonRequest },
});
